import React from "react";
import "./DotLoader.scss";

interface DotLoaderProps {
  className?: string;
}

const DotLoader: React.FC<DotLoaderProps> = ({ className }) => (
  <div className={`dropdown-loading-indicator ${className}`}>
    <div className="loading-dot" />
    <div className="loading-dot" />
    <div className="loading-dot" />
  </div>
);

export default DotLoader;
